/* eslint-disable no-unused-vars */
import axios from '../../helpers/Axios'
import { Promise } from 'es6-promise'

export const filemodule = {
	namespaced: true,	
	actions: {

        getFile({ commit }, [fileName, hash]) {

            const config = { 
                headers: { 
                    'Content-Type': 'application/json', 
                    'Cache-Control': 'no-cache', 
                    'Pragma': 'no-cache',
                    'X-File-Name': fileName,
                    'X-File-Hash': hash
                },
                responseType: 'blob'
            };

			return axios.get('/file', config).then(response => {
				return response;
			}).catch(err => {
				console.log('Failed to get file', err);
				Promise.reject(err.response);
			});
        }
    }
}
